module.exports = __webpack_public_path__ + "static/media/gradiente-destaques.9c953b10.png";